(function () {
    'use strict';

    angular.module('crewProfile')
        .component('crewLayoverAccommodationPreferenceTable', {
            templateUrl: 'profile/components/crew-layover-accommodation-preference-table-component.html',
            controller: CrewLayoverAccommodationPreferenceTableController,
            bindings: {
                preferenceData: '<',
                editLayoverAccommodationPreference: '&',
                deleteLayoverAccommodationPreference: '&'
            }
        });

    CrewLayoverAccommodationPreferenceTableController.$inject = ['$document', '$timeout'];

    function CrewLayoverAccommodationPreferenceTableController($document, $timeout) {

        var ctrl = this;

        ctrl.sortedPreferenceData = [];
        ctrl.filteredData = [];

        ctrl.sortColumn = null;
        ctrl.sortDirection = null;

        ctrl.searchVisible = false;
        ctrl.searchTerm = '';

        ctrl.$onInit = function () {
            if (ctrl.preferenceData) {
                ctrl.filteredData = angular.copy(ctrl.preferenceData);
            }

            // Uncomment if required
            // $document.on('click', ctrl.handleDocumentClick);
        };

        ctrl.$onDestroy = function () {
            $document.off('click', ctrl.handleDocumentClick);
        };

        ctrl.$onChanges = function (changes) {
            if (changes.preferenceData && changes.preferenceData.currentValue) {
                ctrl.filteredData = angular.copy(changes.preferenceData.currentValue);
                ctrl.applyFilterAndSort();
            }
        };

        ctrl.handleDocumentClick = function () {
            if (ctrl.searchVisible) {
                $timeout(function () {
                    ctrl.searchVisible = false;
                });
            }
        };

        ctrl.clickOnRow = function(event, index, selectedRowData, flag) {
          if (flag == 'DELETE') {
            ctrl.deleteLayoverAccommodationPreference({selectedRow : selectedRowData});
          } else if (flag == 'EDIT') {
            ctrl.editLayoverAccommodationPreference({selectedRow : selectedRowData});
          }
        };

        ctrl.toggleSearch = function (event) {
            event.stopPropagation();
            ctrl.searchVisible = !ctrl.searchVisible;

            if (ctrl.searchVisible) {
                $timeout(function () {
                    var input = document.querySelector('.crew-layover-accommodation-preference-table .search-input');
                    if (input) {
                        input.focus();
                    }
                }, 0);
            }
        };

        ctrl.onSearchKeyDown = function (event) {
            if (event.keyCode === 27) {
                ctrl.searchVisible = false;
                ctrl.searchTerm = '';
                ctrl.filterData();
            }
        };

        ctrl.filterData = function () {
            ctrl.filteredData = angular.copy(ctrl.preferenceData);

            if (ctrl.searchTerm && ctrl.searchTerm.trim() !== '') {
                var searchLower = ctrl.searchTerm.toLowerCase().trim();

                ctrl.filteredData = ctrl.filteredData.filter(function (item) {
                    return Object.keys(item).some(function (key) {
                        return item[key] &&
                            item[key].toString().toLowerCase().indexOf(searchLower) !== -1;
                    });
                });
            }

            ctrl.applyFilterAndSort();
        };

        ctrl.applyFilterAndSort = function () {
            ctrl.sortedPreferenceData = angular.copy(ctrl.filteredData);

            if (ctrl.sortColumn) {
                ctrl.applySorting();
            }
        };

        ctrl.sortBy = function (column) {
            if (ctrl.sortColumn === column) {
                if (ctrl.sortDirection === 'asc') {
                    ctrl.sortDirection = 'desc';
                } else if (ctrl.sortDirection === 'desc') {
                    ctrl.sortColumn = null;
                    ctrl.sortDirection = null;
                    ctrl.sortedPreferenceData = angular.copy(ctrl.filteredData);
                    return;
                }
            } else {
                ctrl.sortColumn = column;
                ctrl.sortDirection = 'asc';
            }

            ctrl.applySorting();
        };

        ctrl.applySorting = function () {
            if (!ctrl.sortColumn) {
                return;
            }

            ctrl.sortedPreferenceData.sort(function (a, b) {
                var valueA = a[ctrl.sortColumn];
                var valueB = b[ctrl.sortColumn];

                if (valueA === undefined || valueA === null) valueA = '';
                if (valueB === undefined || valueB === null) valueB = '';

                var comparison = 0;

                if (valueA < valueB) {
                    comparison = -1;
                } else if (valueA > valueB) {
                    comparison = 1;
                }

                return ctrl.sortDirection === 'asc' ? comparison : -comparison;
            });
        };

        ctrl.isSortedBy = function (column, direction) {
            return ctrl.sortColumn === column &&
                   ctrl.sortDirection === direction;
        };

    }
})();
